module.exports = "https://r.nearpod.com/assets/media/image/delete-binder-icon-1e4425203a20f68b47b58a9db7a4b78c.svg";